import axios from 'axios';
import { API_ENDPOINTS } from '../config';

export class AuthService {
  async login(email, password) {
    const response = await axios.post(`${API_ENDPOINTS.main}/auth/login`, {
      email,
      password
    });
    return response.data;
  }

  async register(email, password, promoCode = null) {
    const payload = {
      email,
      password
    };

    // Only include promo_code if provided (backend expects snake_case)
    if (promoCode) {
      payload.promo_code = promoCode;
    }

    const response = await axios.post(`${API_ENDPOINTS.main}/auth/register`, payload);
    return response.data;
  }

  async getCurrentUser(token) {
    const response = await axios.get(`${API_ENDPOINTS.main}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }

  async refreshToken(token) {
    const response = await axios.post(`${API_ENDPOINTS.main}/auth/refresh`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }

  async logout() {
    // For JWT-based auth, logout is primarily client-side
    // But we can still call the backend endpoint for consistency
    try {
      await axios.delete(`${API_ENDPOINTS.main}/auth/logout`);
    } catch (error) {
      // Don't fail logout if backend call fails
      console.warn('Logout backend call failed:', error);
    }
  }

  // Token management
  storeToken(token) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  removeToken() {
    localStorage.removeItem('token');
  }

  // User data management
  parseUserFromToken(tokenData) {
    return {
      id: tokenData.user_id,
      email: tokenData.email,
      role: tokenData.role || 'user',
      tier: tokenData.tier || 'free',
      org_id: tokenData.org_id || null,
      org_name: tokenData.org_name || null
    };
  }
}

// Create singleton instance
export const authService = new AuthService();